import React from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Package, TrendingUp, Clock, CheckCircle, AlertCircle, FileText, Truck, DollarSign, BarChart3, Download } from 'lucide-react';
export function FactoryDashboard() {
  const activePOs = [{
    id: 'PO-FAC-001',
    poNumber: 'PO-2023-001',
    agregator: 'PTX',
    products: [{
      name: 'Indomie Goreng Special',
      quantity: 500,
      unit: 'Karton'
    }, {
      name: 'Indomie Soto',
      quantity: 300,
      unit: 'Karton'
    }],
    totalValue: 28000000,
    status: 'production',
    statusLabel: 'Dalam Produksi',
    orderDate: '10 Okt 2023',
    dueDate: '13 Okt 2023',
    progress: 65,
    estimatedCompletion: '13 Okt 2023'
  }, {
    id: 'PO-FAC-002',
    poNumber: 'PO-2023-005',
    agregator: 'PTX',
    products: [{
      name: 'Indomie Ayam Bawang',
      quantity: 400,
      unit: 'Karton'
    }],
    totalValue: 15000000,
    status: 'ready',
    statusLabel: 'Siap Kirim',
    orderDate: '8 Okt 2023',
    dueDate: '11 Okt 2023',
    progress: 100,
    estimatedCompletion: 'Selesai'
  }];
  return <div className="space-y-6" data-id="element-1762">
      {/* Header */}
      <div data-id="element-1763">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-1764">Dashboard Pabrik</h2>
        <p className="text-sm text-slate-500 mt-1" data-id="element-1765">
          Monitor purchase order dan produksi
        </p>
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-4 gap-4" data-id="element-1766">
        <Card className="p-5 bg-gradient-to-br from-blue-50 to-blue-100 border-blue-200" data-id="element-1767">
          <div className="flex items-center justify-between mb-3" data-id="element-1768">
            <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1769">
              <FileText className="w-6 h-6 text-white" data-id="element-1770" />
            </div>
            <Badge className="bg-blue-200 text-blue-800 border-0" data-id="element-1771">Aktif</Badge>
          </div>
          <p className="text-sm text-blue-700 mb-1" data-id="element-1772">PO Aktif</p>
          <p className="text-4xl font-bold text-blue-900" data-id="element-1773">8</p>
          <p className="text-xs text-blue-600 mt-1" data-id="element-1774">Dalam proses</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-green-50 to-green-100 border-green-200" data-id="element-1775">
          <div className="flex items-center justify-between mb-3" data-id="element-1776">
            <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1777">
              <CheckCircle className="w-6 h-6 text-white" data-id="element-1778" />
            </div>
            <Badge className="bg-green-200 text-green-800 border-0" data-id="element-1779">+15</Badge>
          </div>
          <p className="text-sm text-green-700 mb-1" data-id="element-1780">Selesai Bulan Ini</p>
          <p className="text-4xl font-bold text-green-900" data-id="element-1781">148</p>
          <p className="text-xs text-green-600 mt-1" data-id="element-1782">On-time: 95.2%</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-violet-50 to-violet-100 border-violet-200" data-id="element-1783">
          <div className="flex items-center justify-between mb-3" data-id="element-1784">
            <div className="w-12 h-12 bg-violet-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1785">
              <DollarSign className="w-6 h-6 text-white" data-id="element-1786" />
            </div>
            <Badge className="bg-violet-200 text-violet-800 border-0" data-id="element-1787">
              +22%
            </Badge>
          </div>
          <p className="text-sm text-violet-700 mb-1" data-id="element-1788">Total Nilai PO</p>
          <p className="text-4xl font-bold text-violet-900" data-id="element-1789">Rp 450Jt</p>
          <p className="text-xs text-violet-600 mt-1" data-id="element-1790">Bulan ini</p>
        </Card>

        <Card className="p-5 bg-gradient-to-br from-amber-50 to-amber-100 border-amber-200" data-id="element-1791">
          <div className="flex items-center justify-between mb-3" data-id="element-1792">
            <div className="w-12 h-12 bg-amber-600 rounded-xl flex items-center justify-center shadow-lg" data-id="element-1793">
              <TrendingUp className="w-6 h-6 text-white" data-id="element-1794" />
            </div>
            <Badge className="bg-amber-200 text-amber-800 border-0" data-id="element-1795">Baik</Badge>
          </div>
          <p className="text-sm text-amber-700 mb-1" data-id="element-1796">Avg Lead Time</p>
          <p className="text-4xl font-bold text-amber-900" data-id="element-1797">3.5</p>
          <p className="text-xs text-amber-600 mt-1" data-id="element-1798">hari</p>
        </Card>
      </div>

      {/* Active POs */}
      <Card className="p-6" data-id="element-1799">
        <div className="flex items-center justify-between mb-6" data-id="element-1800">
          <div data-id="element-1801">
            <h3 className="font-bold text-lg text-slate-900" data-id="element-1802">
              Purchase Order Aktif
            </h3>
            <p className="text-sm text-slate-500 mt-1" data-id="element-1803">
              PO yang sedang diproses dan siap kirim
            </p>
          </div>
          <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-1805" />} data-id="element-1804">
            Export Report
          </Button>
        </div>

        <div className="space-y-4" data-id="element-1806">
          {activePOs.map(po => <div key={po.id} className="p-5 bg-slate-50 rounded-xl border border-slate-200" data-id="element-1807">
              <div className="flex items-start justify-between mb-4" data-id="element-1808">
                <div data-id="element-1809">
                  <div className="flex items-center gap-3 mb-2" data-id="element-1810">
                    <h4 className="text-xl font-bold text-slate-900" data-id="element-1811">
                      {po.poNumber}
                    </h4>
                    <Badge variant={po.status === 'ready' ? 'success' : 'warning'} data-id="element-1812">
                      {po.statusLabel}
                    </Badge>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-slate-600" data-id="element-1813">
                    <span data-id="element-1814">Dari: {po.agregator}</span>
                    <span className="text-slate-400" data-id="element-1815">•</span>
                    <span data-id="element-1816">Order: {po.orderDate}</span>
                    <span className="text-slate-400" data-id="element-1817">•</span>
                    <span data-id="element-1818">Due: {po.dueDate}</span>
                  </div>
                </div>
                <div className="text-right" data-id="element-1819">
                  <p className="text-sm text-slate-600 mb-1" data-id="element-1820">Total Nilai</p>
                  <p className="text-2xl font-bold text-blue-600" data-id="element-1821">
                    Rp {(po.totalValue / 1000000).toFixed(1)}Jt
                  </p>
                </div>
              </div>

              {/* Products */}
              <div className="mb-4 p-4 bg-white rounded-lg border border-slate-200" data-id="element-1822">
                <p className="text-xs font-bold text-slate-700 mb-2" data-id="element-1823">Produk:</p>
                <div className="space-y-2" data-id="element-1824">
                  {po.products.map((product, i) => <div key={i} className="flex items-center justify-between text-sm" data-id="element-1825">
                      <span className="text-slate-900" data-id="element-1826">{product.name}</span>
                      <span className="font-medium text-slate-600" data-id="element-1827">
                        {product.quantity} {product.unit}
                      </span>
                    </div>)}
                </div>
              </div>

              {/* Progress */}
              {po.status === 'production' && <div className="mb-4" data-id="element-1828">
                  <div className="flex justify-between items-center mb-2" data-id="element-1829">
                    <span className="text-sm font-medium text-slate-700" data-id="element-1830">
                      Progress Produksi
                    </span>
                    <span className="text-sm font-bold text-slate-900" data-id="element-1831">
                      {po.progress}%
                    </span>
                  </div>
                  <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden" data-id="element-1832">
                    <div className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500" style={{
                width: `${po.progress}%`
              }} data-id="element-1833"></div>
                  </div>
                  <p className="text-xs text-slate-600 mt-1" data-id="element-1834">
                    Est. selesai: {po.estimatedCompletion}
                  </p>
                </div>}

              {/* Actions */}
              <div className="flex gap-2 pt-4 border-t border-slate-200" data-id="element-1835">
                {po.status === 'ready' && <Button variant="primary" size="sm" icon={<Truck className="w-4 h-4" data-id="element-1837" />} data-id="element-1836">
                    Konfirmasi Pengiriman
                  </Button>}
                <Button variant="outline" size="sm" icon={<FileText className="w-4 h-4" data-id="element-1839" />} data-id="element-1838">
                  Lihat Detail PO
                </Button>
                <Button variant="outline" size="sm" icon={<Download className="w-4 h-4" data-id="element-1841" />} data-id="element-1840">
                  Download PDF
                </Button>
              </div>
            </div>)}
        </div>
      </Card>

      {/* Production Stats */}
      <div className="grid grid-cols-2 gap-6" data-id="element-1842">
        <Card className="p-6" data-id="element-1843">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-1844">
            Performa Produksi
          </h3>
          <div className="space-y-4" data-id="element-1845">
            <div data-id="element-1846">
              <div className="flex justify-between items-center mb-2" data-id="element-1847">
                <span className="text-sm text-slate-600" data-id="element-1848">
                  On-Time Completion
                </span>
                <span className="text-sm font-bold text-green-600" data-id="element-1849">95.2%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-1850">
                <div className="h-full bg-green-500 rounded-full" style={{
                width: '95.2%'
              }} data-id="element-1851"></div>
              </div>
            </div>

            <div data-id="element-1852">
              <div className="flex justify-between items-center mb-2" data-id="element-1853">
                <span className="text-sm text-slate-600" data-id="element-1854">Quality Rate</span>
                <span className="text-sm font-bold text-blue-600" data-id="element-1855">98.8%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-1856">
                <div className="h-full bg-blue-500 rounded-full" style={{
                width: '98.8%'
              }} data-id="element-1857"></div>
              </div>
            </div>

            <div data-id="element-1858">
              <div className="flex justify-between items-center mb-2" data-id="element-1859">
                <span className="text-sm text-slate-600" data-id="element-1860">
                  Capacity Utilization
                </span>
                <span className="text-sm font-bold text-violet-600" data-id="element-1861">87%</span>
              </div>
              <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-1862">
                <div className="h-full bg-violet-500 rounded-full" style={{
                width: '87%'
              }} data-id="element-1863"></div>
              </div>
            </div>
          </div>
        </Card>

        <Card className="p-6" data-id="element-1864">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-1865">
            Alerts & Notifications
          </h3>
          <div className="space-y-3" data-id="element-1866">
            <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg" data-id="element-1867">
              <Clock className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-1868" />
              <div data-id="element-1869">
                <h4 className="text-sm font-bold text-amber-800" data-id="element-1870">
                  PO Mendekati Deadline
                </h4>
                <p className="text-xs text-amber-600 mt-1" data-id="element-1871">
                  PO-2023-006 due dalam 1 hari
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-200 rounded-lg" data-id="element-1872">
              <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-1873" />
              <div data-id="element-1874">
                <h4 className="text-sm font-bold text-green-800" data-id="element-1875">
                  Production On Track
                </h4>
                <p className="text-xs text-green-600 mt-1" data-id="element-1876">
                  Semua PO aktif sesuai jadwal
                </p>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>;
}